import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { store } from "./store/store";
import { captureProjectIdFromUrl } from "./store/referral/capture";
import { setProjectId } from "./store/referral/store";

// Capture the MyIKO project_id before React renders, so it survives both the
// login redirect and the configurator's URL rewrites.
const capturedProjectId = captureProjectIdFromUrl();
if (capturedProjectId) {
  store.dispatch(setProjectId(capturedProjectId));
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
